import React from "react";


function Form(props){
    return(
    <div>{props.children}</div>
    );
}

export  default Form;